import { Center, Stack, Text } from "@mantine/core";
import { IconDatabaseOff } from "@tabler/icons-react";
import type { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  description?: string;
  cta?: ReactNode;
}

export function EmptyState({ title, description, cta }: EmptyStateProps) {
  return (
    <Center className="w-full h-full bg-slate-100 rounded-sm">
      <Stack align="center" gap={20}>
        <div className="text-gray-400">
          <IconDatabaseOff size={50} />
        </div>
        <div className="w-full flex flex-col gap-0 items-center">
          <Text size="md">{title}</Text>
          {description && (
            <Text size="xs" c="dimmed">
              {description}
            </Text>
          )}
        </div>
        {cta}
      </Stack>
    </Center>
  );
}
